export default __webpack_public_path__ + "static/3-dac52a4f55a2f0a53c4d7c928503dd14.png";